<template>
  <div class="animated fadeIn compras-abm">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <div slot="header">Crédito / Débito</div>
            <b-row>
              <b-col xl="6">
                <b-form-group
                  label="Proveedor"
                  label-for="proveedor"
                  :label-cols="2"
                  horizontal>
                  <b-form-input 
                    id="proveedor"
                    :value="proveedorNombre"
                    readonly
                    type="text"/>
                </b-form-group>

                <div v-if="formularioVisible" class="grupo-controles">
                  <b-form-group
                    label="Comp."
                    :label-cols="2"
                    horizontal>

                    <comprobante-tipo
                      label="tipo de comprobante"
                      selectId="comprobanteTipo"
                      :showLabel="false"
                      :nombre="comprobanteTipoNombre"
                      :valido="comprobanteTipoValido"
                      :lista="comprobantesTiposList"
                      :msjInvalido="comprobanteTipoInvalidoMsj"
                      @validate="validate"
                      @updated="comprobanteTipoActualizado">
                    </comprobante-tipo>

                    <formulario
                      label="formulario"
                      selectId="formulario"
                      :showLabel="false"
                      :nombre="formulario"
                      :valido="formularioValido"
                      :lista="formularios"
                      :msjInvalido="formularioInvalidoMsj"
                      :readOnly="formularioDisabled"
                      @validate="validate"
                      @updated="formularioActualizado">
                    </formulario>  
                  </b-form-group>
                </div>

                <b-form-group
                  v-if="!formularioVisible"
                  label="Comp."
                  :label-cols="2"
                  horizontal>

                  <comprobante-tipo
                    label="tipo de comprobante"
                    selectId="comprobanteTipo"
                    :showLabel="false"
                    :nombre="comprobanteTipoNombre"
                    :valido="comprobanteTipoValido"
                    :lista="comprobantesTiposList"
                    @validate="validate"
                    @updated="comprobanteTipoActualizado">
                  </comprobante-tipo>
                  <b-form-invalid-feedback id="comprobanteTipoFeedback">
                    {{ comprobanteTipoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <div v-if="puntoVentaVisible" class="grupo-controles">
                  <b-form-group
                    label="Número"
                    label-for="numero"
                    :label-cols="2"
                    horizontal>
                    <b-form-input 
                      id="numeroPuntoVenta"
                      v-model.trim= "$v.numeroPuntoVenta.$model" 
                      :state="numeroPuntoVentaValido"
                      type="number"
                      min="0000" max="9999"
                      :readonly="numeroPuntoVentaDisabled"
                      @blur.native="validate">
                    </b-form-input>
                    <b-form-input 
                      id="numero"
                      v-model.trim= "$v.numero.$model" 
                      :state="numeroValido"
                      type="number"
                      @blur.native="validate">
                    </b-form-input>
                    <b-form-invalid-feedback id="numeroFeedback">
                      {{ numeroInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>
                </div>

                <b-form-group
                  v-if="!puntoVentaVisible"
                  label="Número"
                  label-for="numero"
                  :label-cols="2"
                  horizontal>
                  <b-form-input 
                    id="numero"
                    v-model.trim= "$v.numero.$model" 
                    :state="numeroValido"
                    type="number"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="numeroFeedback">
                    {{ numeroInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>

              <b-col xl="6">
                <b-form-group
                  label="Fecha Comp."
                  label-for="fechaComprobante"
                  :label-cols="3"
                  horizontal>
                  <b-form-input 
                    id="fechaComprobante" 
                    v-model= "fechaComprobante" 
                    type="date">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Fecha Venc."
                  label-for="fechaVencimiento"
                  :label-cols="3"
                  :description="leyendaPlazo"
                  horizontal>
                  <b-form-input 
                    id="fechaVencimiento" 
                    v-model= "fechaVencimiento" 
                    type="date">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Periodo"
                  label-for="periodo"
                  :label-cols="3"
                  horizontal>
                  <b-form-select 
                    v-model="periodoMesNombre" 
                    :options="meses" 
                    :state="periodoValido"
                    class="mb-3 select-fecha select-fecha-mes"
                    @blur.native="validate">
                    <template slot="first">
                      <option :value='null'>Seleccione un mes</option>
                      <!--<option :value='null' :disabled='Boolean(true)'>Seleccione un mes</option>-->
                    </template>
                  </b-form-select>
                  <b-form-select 
                    v-model="periodoAnio" 
                    :options="anios" 
                    :state="periodoValido"
                    class="mb-3 select-fecha select-fecha-anio"
                    @blur.native="validate">
                    <template slot="first">
                      <option :value="0">Seleccione un año</option>
                      <!--<option :value="0" :disabled='Boolean(true)'>Seleccione un año</option>-->
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="periodoFeedback">
                    {{ periodoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <app-totales
            ref="totales"
            :noValidar="noValidar"
            :readOnly="true">
          </app-totales>

          <b-form-group
            label-for="observaciones">
            <b-form-textarea
              id="observaciones"
              v-model= "$v.observaciones.$model" 
              rows="3"
              max-rows="6"
              :state="observacionesValidas"
              @blur.native="validate">
            </b-form-textarea>
            <b-form-invalid-feedback id="observacionesFeedback">
              {{ observacionesInvalidasMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import { required, requiredIf, decimal, minValue, maxValue, numeric, maxLength, minLength, between } from 'vuelidate/lib/validators';
import ABMButtons from '../shared/abmButtons.vue';
import ComprobanteTipo from '../shared/abmSelectSimple.vue';
import Formulario from '../shared/abmSelectSimple.vue';
import Totales from './Totales.vue'
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'compra/getField',
  mutationType: 'compra/updateField',
});

const NumeroComprobanteValido = ((value, vm) => {
  // Si no hay valor, es inválido
  if (!value || value === 0 || value === '0') {
    return false;
  }
  
  // Convertir a string para validar
  const valueStr = value.toString().trim();
  
  // Verificar que solo contenga dígitos
  if (!/^\d+$/.test(valueStr)) {
    return false;
  }
  
  // Verificar que no exceda los dígitos permitidos
  if (valueStr.length > vm.digitosNumeroComprobante) {
    return false;
  }
  
  // Verificar que no sea solo ceros
  if (parseInt(valueStr) === 0) {
    return false;
  }
  
  return true;
});

export default {
  name: 'CompraCreditoDebito',
  components: {
    ComprobanteTipo,
    Formulario,
    appTotales: Totales,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      periodoValido: null,
      periodoInvalidoMsj: '',
      comprobanteTipoValido: null,
      comprobanteTipoInvalidoMsj: '',
      formularioValido: null,
      formularioInvalidoMsj: '',
      numeroPuntoVentaValido: null,
      numeroValido: null,
      numeroInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      meses: [],
      anios: [],

      inicializando: Boolean(false),
      tableBusy: false,
      readOnly: Boolean(true),
    }
  },
  computed: {
    ...mapFields([
      'compraId',

      'proveedorNombre',
      'fechaComprobante',
      'fechaVencimiento',
      'plazoPago',
      'periodo',
      'periodoMesNombre',
      'periodoAnio',
      'comprobanteTipo',
      'comprobanteTipoNombre',
      'formulario',
      'formularios',
      'numeroPuntoVenta',
      'numero',
      'observaciones',
      'total', 
      'montoBase1', 
      'pjeAlicuota1',
      'montoBase2',
      'pjeAlicuota2', 
      'montoBase3',
      'pjeAlicuota3',
      'percepcionesProvinciales',

      'formularioDisabled',
      'numeroPuntoVentaDisabled', 
      'numeroDisabled',
      'formularioVisible',
      'puntoVentaVisible',
      'digitosNumeroComprobante',

      'comprobantesTipos',
      'comprobantesTiposList'

    ]),
    leyendaPlazo() {
      if (this.plazoPago) {
        if (this.plazoPago != 0) {
          return `Plazo de Pago: ${this.plazoPago.toString().trim()} días`;
        }
      }
      return '';
    },
  },
  created() {
    this.getDatosAdicionales();
    
    let compraId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        compraId = this.$route.params.id;
      }
    }

    let params = {
      compraId,
      creditoParcial: false
    }

    this.inicializando = true;
    this.showSpinner();
    this.$store.dispatch('compra/inicializarCreditoDebito', params)
      .then(() => this.inicializando = false)
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      this.meses = this.getMeses();
      this.anios = this.getAniosPeriodo();
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (this.puntoVentaVisible) {
        if (campo == 'numeroPuntoVenta' || validarTodos) {
          if (this.$v.numeroPuntoVenta.$error) {
            this.numeroPuntoVentaValido = false;
          } else {
            this.numeroPuntoVentaValido = null;
          }
        }
      }

      if (campo == 'numero' || validarTodos) {
        if (this.$v.numero.$error) {
          this.numeroValido = false;
        } else {
          this.numeroValido = null;
        }
      }

      if (!this.numeroValido || !this.numeroPuntoVentaValido) {
        if (this.puntoVentaVisible) {
          this.numeroInvalidoMsj = 'Verifique la información del número y del punto de venta.';
        } else {
          this.numeroInvalidoMsj = 'Verifique la información del número.';
        }
      } else {
        this.numeroInvalidoMsj = '';
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 500 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }

      if (campo == 'montoBase1' || validarTodos) {
        this.montoBase1Valido = null;
        if (this.$v.montoBase1.$error) {
          this.montoBase1Valido = false;
        }
      }
      if (campo == 'pjeAlicuota1' || validarTodos) {
        this.pjeAlicuota1Valida = null;
        if (this.$v.pjeAlicuota1.$error) {
          this.pjeAlicuota1Valida = false;
        }
      }

      if (this.montoBase1Valido == false || this.pjeAlicuota1Valida == false) {
        this.baseAlicuota1InvalidosMsj = 'El monto base y la alícuota ingresados no son válidos.';
      } else {
        this.baseAlicuota1InvalidosMsj = '';
      }

      if (campo == 'montoBase2' || validarTodos) {
        this.montoBase2Valido = null;
        if (this.$v.montoBase2.$error) {
          this.montoBase2Valido = false;
        }
      }
      if (campo == 'pjeAlicuota2' || validarTodos) {
        this.pjeAlicuota2Valida = null;
        if (this.$v.pjeAlicuota2.$error) {
          this.pjeAlicuota2Valida = false;
        }
      }

      if (this.montoBase2Valido == false || this.pjeAlicuota2Valida == false) {
        this.baseAlicuota2InvalidosMsj = 'El monto base y la alícuota ingresados no son válidos.';
      } else {
        this.baseAlicuota2InvalidosMsj = '';
      }

      if (campo == 'montoBase3' || validarTodos) {
        this.montoBase3Valido = null;
        if (this.$v.montoBase3.$error) {
          this.montoBase3Valido = false;
        }
      }
      if (campo == 'pjeAlicuota3' || validarTodos) {
        this.pjeAlicuota3Valida = null;
        if (this.$v.pjeAlicuota3.$error) {
          this.pjeAlicuota3Valida = false;
        }
      }

      if (this.montoBase3Valido == false || this.pjeAlicuota3Valida == false) {
        this.baseAlicuota3InvalidosMsj = 'El monto base y la alícuota ingresados no son válidos.';
      } else {
        this.baseAlicuota3InvalidosMsj = '';
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      // let comprobanteTipo;
      // if (this.comprobanteTipoNombre) {
      //   comprobanteTipo = this.getSelected(this.comprobantesTipos, this.comprobanteTipoNombre);
      // }
      // this.$store.dispatch('compra/setComprobanteTipo', comprobanteTipo);

      let comprobanteTipoError = true;
      if (this.comprobanteTipo) {
        if (this.comprobanteTipo.id) {
          if (this.comprobanteTipo.id != 0) {
            comprobanteTipoError = false;
          }
        }
      }
      if (comprobanteTipoError) {
        save = Boolean(false);
        this.comprobanteTipoValido = false;
        this.comprobanteTipoInvalidoMsj = "Debe seleccionar el tipo de comprobante correspondiente.";
      }

      if (this.formularioVisible) {
        if (this.formulario.trim() == '') {
          save = Boolean(false);
          this.formularioValido = false;
          this.formularioInvalidoMsj = "Debe seleccionar el formulario correspondiente.";
        }
      }

      let mes = this.getMesNumero(this.periodoMesNombre);
      let anio = parseInt(this.periodoAnio);

      if (!this.isValidDate(1, mes, anio))
      {
        this.periodoValido = false;
        this.periodoInvalidoMsj = 'Debe seleccionar el período del comprobante.';
        save = Boolean(false);
      } else {
        this.periodoValido = null;
        this.periodoInvalidoMsj = '';
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        // console.log('Errores', this.$v);
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('compra/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.go(-1);
    },

    comprobanteTipoActualizado(comprobanteTipoNombre) {
      if (!this.inicializando) {
        this.comprobanteTipoNombre = comprobanteTipoNombre;

        let comprobanteTipo;
        if (this.comprobanteTipoNombre) {
          comprobanteTipo = this.getSelected(this.comprobantesTipos, this.comprobanteTipoNombre);
        }
        
        this.$store.dispatch('compra/setComprobanteTipo', comprobanteTipo);
        this.$store.dispatch('compra/calcularMontos')

        this.comprobanteTipoValido = null;
        this.comprobanteTipoInvalidoMsj = '';
      }
    },    
    formularioActualizado(formulario) {
      if (!this.inicializando) {
        this.formulario = formulario;

        this.formularioValido = null;
        this.formularioInvalidoMsj = '';
      }
    },    

  },
  validations: {
    numeroPuntoVenta: {
      required: requiredIf(function () {
        return this.puntoVentaVisible;
      }),
      numeric,
      minValue: minValue(0),
      maxValue: maxValue(9999)
    },
    numero: {
      NumeroComprobanteValido
      // required,
      // numeric,
      // minValue: minValue(1),
      // maxValue: maxValue(99999999)
    },
    total: { decimal, minValue: minValue(0) },
    cotizacion: { decimal, minValue: minValue(0) },
    montoBase1: { decimal, minValue: minValue(0) },
    montoBase2: { decimal, minValue: minValue(0) },
    montoBase3: { decimal, minValue: minValue(0) },
    pjeAlicuota1: { decimal, minValue: minValue(0) },
    pjeAlicuota2: { decimal, minValue: minValue(0) },
    pjeAlicuota3: { decimal, minValue: minValue(0) },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
    'fechaComprobante' : function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$store.dispatch('compra/calcularFechaVencimiento');
      }
    },
    'formulario' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontosTotal')
    },
    'total' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontosTotal')
    },
    'montoBase1' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'montoBase2' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'montoBase3' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'pjeAlicuota1' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'pjeAlicuota2' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'pjeAlicuota3' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },    
  },
}
</script>

<style>
.compra-ordenes-proveedores table td[aria-colindex="1"] {
  width: 10%;
}
.compra-ordenes-proveedores table td[aria-colindex="2"] {
  width: 10%;
}
.compra-ordenes-proveedores table td[aria-colindex="3"] {
  width: 48%;
}
.compra-ordenes-proveedores table td[aria-colindex="4"],
.compra-ordenes-proveedores table td[aria-colindex="5"],
.compra-ordenes-proveedores table td[aria-colindex="6"] {
  width: 10%;
}

</style>
